import { ReactComponent as EmailIcon } from '../../assets/image/svg/emailIcon.svg'
import { ReactComponent as PhoneIcon } from '../../assets/image/svg/phoneIcon.svg'
import { ReactComponent as PinIcon } from '../../assets/image/svg/addressIcon.svg'
import { ReactComponent as BriefcaseIcon } from '../../assets/image/svg/businessIcon.svg'

const ContactIcon = ({ type, className }) => {
  switch (type) {
    case 'email':
  return <EmailIcon className={className}  />
    case 'phone':
  return <PhoneIcon className={className} />
    case 'address':
  return <PinIcon className={className}/>
    case 'business':
      return <BriefcaseIcon className={className} />
    default:
      return null
  }
}

export default ContactIcon
